import axios from 'axios';

import { getSchedulingServerURL } from '../helper';
import { Organization, InterviewSetting, ContextType } from '../Types';

export interface Interviewer {
    id: string;
    name: string;
    email: string;
    type: PARTICIPANT_TYPE;
}

export enum PARTICIPANT_TYPE {
    VIRTUAL_CALENDAR = 'VirtualCalendar',
    INTERVIEWER = 'Interviewer',
}

export async function getOrganizationDetails(organizationId: string): Promise<Organization> {
    const { data } = await axios.get(`${getSchedulingServerURL()}/admin/organization/${organizationId}`);

    return data.organization;
}

export const isEnabled = async (feature: string, hpAccountId?: string): Promise<boolean> => {
    const { data } = await axios.get(`${getSchedulingServerURL()}/admin/feature/${feature}`, {
        params: {
            hpAccountId,
        },
    });

    return data;
};

export const isFeatureEnabled = async (feature: string, context?: ContextType): Promise<boolean> => {
    const { data } = await axios.post(`${getSchedulingServerURL()}/admin/feature/${feature}`, {
        context,
    });

    return data;
};

export async function getActiveInterviewersAndVirtualCalendars(organizationId: string): Promise<Interviewer[] | []> {
    const { data } = await axios.get(
        `${getSchedulingServerURL()}/admin/organization/${organizationId}/active-interviewers`,
    );

    return data;
}

export async function getInterviewSettingsForOrganization(organizationId: string): Promise<InterviewSetting[] | []> {
    const { data } = await axios.get(
        `${getSchedulingServerURL()}/admin/interview/organization/${organizationId}/settings`,
    );

    return data;
}
